<template>
  <div class="page-link">
    <router-link :to="`/${to}`">
      <slot />
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'CtaButton',

  props: {
    to: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
.page-link {
  width: auto;
  height: auto;
  display: block;
  padding: 0px;
  margin: 0px;
  pointer-events: none;
}

.page-link a {
  padding: 8px;
  background-color: #c1f6ed;
  text-transform: uppercase;
  font-family: 'Alata';
  font-size: 1.2rem;
  text-decoration: none;
  position: relative;
  z-index: 4;
  pointer-events: all;
  border: 2px solid #1c2534;
}

.page-link:before {
  content: '';
  display: block;
  width: 60px;
  height: 30px;
  position: relative;
  left: -5px;
  top: 20px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.page-link:hover:before {
  content: '';
  display: block;
  width: 60px;
  height: 30px;
  position: relative;
  left: -5px;
  top: 20px;
  background-image: linear-gradient(to bottom right, #ffe083, #c1f6ed);
  opacity: 0.75;
  animation: expandWidthTop 0.5s ease-in-out;
}

.page-link:after {
  content: '';
  display: block;
  width: 60px;
  height: 30px;
  position: relative;
  right: calc(-100% + 55px);
  bottom: 20px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.page-link:hover:after {
  content: '';
  display: block;
  width: 60px;
  height: 30px;
  position: relative;
  right: calc(-100% + 55px);
  bottom: 20px;
  background-image: linear-gradient(to bottom right, #c1f6ed, #ffe083);
  opacity: 0.75;
  animation: expandWidthBottom 0.5s ease-in-out;
}

@keyframes expandWidthTop {
  from {
    width: 0px;
  }

  to {
    width: 60px;
  }
}

@keyframes expandWidthBottom {
  from {
    width: 0px;
    right: calc(-100% - 5px);
  }

  to {
    width: 60px;
    right: calc(-100% + 55px);
  }
}

/* DESKTOP */
@media screen and (orientation: landscape) {
  .page-link a {
    padding: 16px;
    background-color: #c1f6ed;
    text-transform: uppercase;
    font-family: 'Alata';
    font-size: 1.25rem;
    text-decoration: none;
    position: relative;
    z-index: 2;
  }

  .page-link:before {
    content: '';
    display: block;
    width: 60px;
    height: 50px;
    position: relative;
    left: -10px;
    top: 25px;
    border-top-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .page-link:hover:before {
    content: '';
    display: block;
    width: 60px;
    height: 50px;
    position: relative;
    left: -10px;
    top: 25px;
    background-image: linear-gradient(to bottom right, #ffe083, #c1f6ed);
    opacity: 0.75;
    animation: expandWidthTop 0.5s ease-in-out;
  }

  .page-link:after {
    content: '';
    display: block;
    width: 60px;
    height: 50px;
    position: relative;
    right: calc(-100% + 50px);
    bottom: 25px;
    border-top-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .page-link:hover:after {
    content: '';
    display: block;
    width: 60px;
    height: 50px;
    position: relative;
    right: calc(-100% + 50px);
    bottom: 25px;
    background-image: linear-gradient(to bottom right, #c1f6ed, #ffe083);
    opacity: 0.75;
    animation: expandWidthBottom 0.5s ease-in-out;
  }

  @keyframes expandWidthTop {
    from {
      width: 0px;
    }

    to {
      width: 60px;
    }
  }

  @keyframes expandWidthBottom {
    from {
      width: 0px;
      right: calc(-100% - 10px);
    }

    to {
      width: 60px;
      right: calc(-100% + 50px);
    }
  }
}
</style>
